module.exports = __webpack_public_path__ + "register/img/404.dced3671.jpg";